import React, { useState } from 'react';

import { useClassnames } from '@lumapps/classnames';

import { ACTIONABLE_ITEM_TYPES, ActionableItemPayload } from '../../types';
import { isActionableItemValid } from '../../utils';
import { AskAiCardContent } from './AskAiCardContent';

import './index.scss';

const CLASSNAME = 'ask-ai-card';

export interface AskAiCardProps {
    className?: string;
    actionableItem?: ActionableItemPayload;
    query: string;
    onLoad?: (isLoaded: boolean) => void;
}

/**
 * Display the given micro app or adaptive card wrapped in SeeMoreFade component
 */
export const AskAiCard: React.FC<AskAiCardProps> = ({ onLoad, className, ...props }) => {
    const { block, element } = useClassnames(CLASSNAME);
    const { actionableItem } = props;

    /**
     * We need to track the loading state of the card to be able to correctly display the loading style.
     * For now, only the micro app has a specific loading state.
     */
    const [isLoading, setIsLoading] = useState(actionableItem?.type === 'micro_app');

    const handleOnLoad = (isLoaded: boolean) => {
        setIsLoading(!isLoaded);
        if (onLoad) {
            onLoad(isLoaded);
        }
    };

    if (!actionableItem || !isActionableItemValid(actionableItem)) {
        return null;
    }

    return (
        <div
            className={block({ loading: isLoading, images: actionableItem.type === ACTIONABLE_ITEM_TYPES.IMAGES }, [
                className,
            ])}
        >
            <AskAiCardContent
                className={
                    actionableItem?.type
                        ? element(actionableItem?.type.replace('_', '-'), { loading: isLoading })
                        : undefined
                }
                {...props}
                setIsLoaded={handleOnLoad}
            />
        </div>
    );
};
